<template>
    <div v-if="fullWidth">
        <h5
            v-if="title"
            class="type-primary font-medium mb-4"
            :class="{ 'pl-8': fullWidth }"
        >
            {{ title }}
        </h5>
        <slot />
        
    </div>
    <div v-else class="rounded-md border border-keyline-primary overflow-hidden sm-record-section">
        <div class="border-b border-keyline-primary bg-gray-tier-5 rounded-t-md flex flex-wrap items-center justify-between h-[48px]">
            <h2 class="py-2 px-4 font-medium">{{ title }}</h2>
        </div>
        <slot />
    </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    record: {
        type: Object,
        required: true,
    },
    fullWidth: {
        type: Boolean,
        required: false,
        default: false,
    },
});

console.log(props);
</script>
